import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Mouth_5 = ({ skinColours, lipColours }) => {
  const colour0 = lipColours.shadow;
  const colour1 = lipColours.base;
  const colour2 = '#40332E';
  const colour3 = '#FFFEF0';
  const colour4 = '#FFE9CF';
  const colour5 = '#F2D5B2';
  const colour6 = skinColours.shadow;
  const colour7 = lipColours.shadow;

  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M490.2,527.2c-28.2,8.3-56.8,10.4-87,10.8c-28.6,0.4-60.7-2.6-91.8-12.7c-4.1-1.3-6.4,6.9-4,11.5
		c7.6,15.2,44.3,81.9,97,82.1c53.4,0.2,84.5-72.1,89.7-83.6C495.2,532.9,493.7,526.1,490.2,527.2z"
        />
        <path
          fill={colour1}
          d="M490.2,527c-28.2,7.9-56.8,8.3-86.9,7.5c-31.7-0.8-60.8,0.2-91.8-9.3c-4.1-1.3-6.4,6.5-4,10.9
		c7.6,14.3,44.3,77.2,97,77.4c53.4,0.2,84.5-68,89.7-78.8C495.2,532.5,493.7,526.1,490.2,527z"
        />
        <path
          fill={colour0}
          d="M486.5,530.3c-27.1,7.2-54.4,10.5-83.3,10.8c-27.4,0.3-58.4-3.3-90.2-14c-2.7-0.9-3.4,7.8-2.2,10.3
		c6.5,13.6,41.8,64.9,92.4,65.1c51.2,0.1,81.9-54.8,86.9-64.7C491.2,535.8,489.9,529.4,486.5,530.3z"
        />
        <path
          fill={colour2}
          d="M486.9,533.9c-0.5-1.4-2-2.2-3.5-1.8c-51,13.3-102.7,18.3-165.9-2.4c-1.5-0.5-3,0.2-3.8,1.5l0,0
		c-1.3,2.5-1.3,5.5,0.1,7.9c8.7,16,40.6,61.8,88.6,61.9c51.6,0.1,78.4-49.4,84.2-61.7C487.4,537.7,487.5,535.7,486.9,533.9
		L486.9,533.9z"
        />
        <path
          fill={colour3}
          d="M466.2,557.1c0,0,6.8-3,12.4-9.9c2.4-3,3.3-5.8,3.6-10.2c0-0.4-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.2-0.3
		c-49.3,11.7-99.5,15.9-160.3-2.2c-0.5-0.1-1-0.1-1.4,0.2c-0.4,0.3-0.7,0.8-0.7,1.2c-0.2,4.1,0.3,8.7,2.8,10.9
		c4.1,3.7,12.4,9.8,13.7,10.2c0,0-0.1,5,4.5,13.5c15.4,14.2,37.5,27.5,63.5,27.5c27.4,0,49.2-14.8,63.4-29.6
		C467.4,563.7,466.5,560,466.2,557.1z"
        />
        <g>
          <path
            fill={colour4}
            d="M330.2,555.4c6.9,3,26.5,8.1,51.7,10.1c-17.2-2-36.4-6.6-57-15.3L330.2,555.4z"
          />
          <path
            fill={colour4}
            d="M469.4,553.1c0,0-19.1,10.2-50.7,13c17.6-0.5,35.3-1.7,51.9-9.8L469.4,553.1z"
          />
          <path
            fill={colour4}
            d="M418.7,566.1c-3.2,0.1-6.5,0.1-9.7,0.2c-9.5,0.2-18.6-0.1-27.2-0.8C395.4,567.1,407.8,567,418.7,566.1z"
          />
        </g>
        <path
          fill={colour5}
          d="M403.7,594c-26.8,0-58.8-16.5-68-31.9c0.7,2,1.4,4.8,2.9,7.7c15.4,14.2,38,27.9,64.1,27.9
		c27.4,0,49.3-15.2,63.5-30c0.8-1.8,0.6-4,0.5-5.7C463.6,571.5,430.5,594,403.7,594z"
        />
        <path
          fill={colour5}
          d="M319.4,538.6c60.8,18.2,111,13.9,160.3,2.2c0.3-0.1,0.6,2.7,0.9,2.9c0.9-1.9,1.3-4,1.5-6.8
		c0-0.4-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.2-0.3c-49.3,11.7-99.5,15.9-160.3-2.2c-0.5-0.1-1-0.1-1.4,0.2c-0.4,0.3-0.7,0.8-0.7,1.2
		c-0.1,2.2,0,4.6,0.5,6.6C318.8,541.3,319.1,538.5,319.4,538.6z"
        />
        <path
          fill={colour6}
          d="M381.3,525l0.3-1.1c0,0,18.1,5.3,44.8,2.8c0,0-18.8,4.9-21,5C400.1,531.9,381.3,525,381.3,525z"
        />
        <path
          fill={colour6}
          d="M378.6,620.4c5.2,3.4,14.9,8.5,27,12.3c2.6,0.8,25.1-11.8,25.1-11.8s-19.8,5.2-25.9,4.7
		C393.6,624.6,395.3,625.2,378.6,620.4z"
        />
        <g>
          <path
            fill={colour2}
            d="M456.3,559.1c7.5-1.7,12,0,11.9,1.6l10.7-13.5C471.9,555.1,456.3,559.1,456.3,559.1z"
          />
        </g>
        <path
          fill={colour2}
          d="M319.3,545.9l12.1,11.4c8.4,2.7,24.7,4.7,24.7,4.7C337.5,558.3,323.2,548.8,319.3,545.9z"
        />
        <path
          fill={colour2}
          d="M335.1,555.8c0,0,1.7-2.2,2.8-1.7c1.1,0.5,1.9,3.8,1.9,3.8L335.1,555.8z"
        />
        <path
          fill={colour2}
          d="M463.2,556.8c3.7-0.6,4.9-3.3,5.2-6.9c0,0,0.1,3.3,3.9,3.1c0,0-0.2,3.6-3.9,4.1
		C464.7,557.7,463.2,556.8,463.2,556.8z"
        />
        <path
          fill={colour7}
          d="M416.3,607.5c-2-1.2-6.8-2-11.5-1.8c-5.2,0.2-9.8,1.6-9.6,3.2c0.3,2.2,7.6,3.6,15,2.7
		C416.6,611,418.7,609,416.3,607.5z"
        />
        <path
          fill={colour7}
          d="M427.5,605.4c-1-0.8-3.5-1.3-5.8-1.2c-2.6,0.1-4.8,1-4.7,2.1c0.2,1.4,3.9,2.3,7.6,1.8
		C427.8,607.7,428.8,606.4,427.5,605.4z"
        />
        <path
          fill={colour2}
          d="M431.6,564.9c3.2-0.1,6.9,0.2,15.1-2.5L431.6,564.9z"
        />
        <path
          fill={colour5}
          d="M424.9,547c2.1,2.9,3.6,5.4,3.7,9.4c-0.2-4.6,0.5-7.2,2.3-9.7L424.9,547z"
        />
        <path
          fill={colour5}
          d="M415.6,594.6c-2.1-2.8-3.5-5.3-3.7-9.3c0.2,4.6-0.6,7.1-2.3,9.6L415.6,594.6z"
        />
        <path
          fill={colour2}
          d="M346.5,560.3c2.1,1,2.3,2.3,3,4.9c0.5-2.6,0.8-2.9,1.9-4.2L346.5,560.3z"
        />
        <path
          fill={colour6}
          d="M488.4,521.7c9.1-3.6,17-0.6,8.9,19.4c0,0,9.3-12.6,5.2-21.4C499.9,514.3,488.4,521.7,488.4,521.7z"
        />
        <path
          fill={colour6}
          d="M308,519c-9-4.3-16.9-0.8-8.9,23.5c0,0-9.3-15.3-5.2-25.8C296.5,510,308,519,308,519z"
        />
        <g>
          <path
            fill={colour4}
            d="M393.2,583.1c0-1,0-2.7-0.2-4.6C393,581.1,393.2,583.1,393.2,583.1z"
          />
          <path
            fill={colour4}
            d="M397.5,566.4l-8.9-0.2c2.5,0.5,3.8,7.2,4.3,12.3C393,573.7,393.6,566.6,397.5,566.4z"
          />
        </g>
      </g>
    </>
  );
};

export default Mouth_5;
